import { helpers } from "vuelidate/lib/validators";

export default size =>
  helpers.withParams({ type: "size", size: size }, files => {
    if (!helpers.req(files)) return false;
    if (isNaN(size)) return false;
    if (!Array.isArray(files)) files = [files];
    const nSize = Number(size) * 1024;
    return files.every(file => file.size <= nSize);
  });
